import { observer } from "mobx-react";
import HeroSection from "@/components/sections/HeroSection";
import FeaturedProducts from "@/components/sections/FeaturedProducts";
import ProductsSlider from "@/components/sections/ProductsSlider";
import CTA from "@/components/sections/CTA";
import CategoriesList from "@/components/sections/CategoriesList";
import AboutSection from "@/components/sections/AboutSection";
import BannerSection from "@/components/sections/BannerSection";
import ContentSection from "@/components/sections/ContentSection";
import ImageContentSideBySide from "@/components/sections/ImageContentSideBySide";
const SectionsRenderer = observer(
  ({ sections, featuredProductsList = [], sliderProductsList = [], crossSellProducts }) => {
    let featuredIndex = 0;
    let sliderIndex = 0;

    // Helper function to render section based on acf_fc_layout
    const renderSection = (section) => {
      switch (section.acf_fc_layout) {
        case "Hero_Section":
          return (
            <HeroSection key={section.acf_fc_layout + Math.floor(Math.random() * 100)} slides={section.slides} />
          );
        case "Featured_Products": {
          const products = featuredProductsList[featuredIndex] || [];
          featuredIndex++;
          return (
            <FeaturedProducts
              key={section.acf_fc_layout + Math.floor(Math.random() * 100) + featuredIndex}
              sectionTitle={section.title}
              backgroundColor={section.background_color}
              products={products}
              crossSellProducts={crossSellProducts}
              ad={section.ad}
            />
          );
        }
        case "Products_Slider": {
          const products = sliderProductsList[sliderIndex] || [];
          sliderIndex++;
          return (
            <ProductsSlider
              key={section.acf_fc_layout + Math.floor(Math.random() * 100) + sliderIndex}
              sectionTitle={section.title}
              backgroundColor={section.background_color}
              products={products}
              crossSellProducts={crossSellProducts}
            />
          );
        }
        case "CTA":
          return (
            <CTA
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              sectionImage={section.image}
              sectionLink={section.link}
              backgroundColor={section.background_color}
              sectionContainer={section.container}
              sectionTitle={section.title}
              sectionText={section.text}
              sectionButtonText={section.button_text}
              ctaBackgroundColor={section.cta_background_color}
            />
          );
        case "Recommended_Categories":
          return (
            <CategoriesList
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              sectionTitle={section.title}
              backgroundColor={section.design.background_color}
              sectionContainer={section.design.container}
              categoriesList={section.categories}
              categoryBackgroundColor={section.design.container_background_color}
            />
          );
        case "About":
          return (
            <AboutSection
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              sectionTitle={section.title}
              backgroundColor={section.background_color}
              backgroundImage={section.background_image}
              sectionRightImage={section.right_image}
              sectionLeftImage={section.left_image}
              sectionContent={section.content}
              buttonText={section.button_text}
              buttonLink={section.button_link}
            />
          );
        case "Banner":
          return (
            <BannerSection
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              banner_image={section.banner_image}
            />
          );
        case "Content":
          return (
            <ContentSection
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              content={section.content}
            />
          );
        case "Image_Content_side_by_side":
          return (
            <ImageContentSideBySide
              key={section.acf_fc_layout + Math.floor(Math.random() * 100)}
              sectionImage={section.image}
              sectionLink={section.link}
              backgroundColor={section.background_color}
              sectionContainer={section.container}
              sectionTitle={section.title}
              sectionText={section.text}
              sectionButtonText={section.button_text}
            />
          );
        default:
          return null; // If section type is not recognized
      }
    };

    return (
      <div className="sections-wrapper">
        {sections && sections.map(renderSection)}
      </div>
    );
  },
);

export default SectionsRenderer;
